module.exports = __webpack_public_path__ + "static/media/permit.b789d38d.png";